import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SignoGerenciadora } from '../gerencias-interface/gerencias-interface';
import { SignoGerenciasService } from '../gerencias-service/gerencias.service';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';

@Component({
  selector: 'app-gerencias-alta',
  templateUrl: './gerencias-alta.component.html',
  styleUrls: ['./gerencias-alta.component.scss']
})
export class GerenciasAltaComponent implements OnInit {
  form: FormGroup;

  constructor(
    private signoGerenciasService: SignoGerenciasService,
    private router: Router,
    private guiMsjService: GuiMsjService
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  get gerenciaNoValido() {
    return this.form.get('nombre').invalid && this.form.get('nombre').touched;
  }

  createForm() {
    this.form = new FormGroup({
      nombre: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(50),
      ]),
      activa: new FormControl(false),
    });
  }

  async createGerencia() {
    if (this.form.valid) {
      await this.guiMsjService.msjFormSubmit('Guardando');
      this.signoGerenciasService.create(await this.setDataForma());
      await this.guiMsjService.msjFormSubmit('DatosGuardados');
      this.router.navigateByUrl('/gerenciadoras-listado');
    } else {
      this.form.markAllAsTouched();
      console.log('Error de validación: Formulario inválido. Por favor, revise los campos.');
    }
  }

  async setDataForma(): Promise<SignoGerenciadora> {
    const gerencia: SignoGerenciadora = {
      nombre: this.form.get('nombre').value || '',
      activa: this.form.get('activa').value === true,
    };
    return gerencia;
  }
}